import { motion } from 'framer-motion'
import DocsLayout from '../components/DocsLayout'
import SEO from '../components/SEO'
import {
  FaMusic,
  FaPlay,
  FaFileWord,
  FaEdit,
  FaCheckSquare,
  FaKeyboard,
  FaShieldAlt,
  FaFileArchive,
  FaCamera,
  FaDesktop,
  FaFilm,
  FaCode,
  FaTerminal,
  FaWindows,
  FaLaptop,
  FaTools,
  FaCompactDisc,
  FaKey,
  FaDownload,
  FaApple,
  FaUsb
} from 'react-icons/fa'

const softwareCategories = [
  {
    name: "音频",
    icon: <FaMusic className="text-blue-500" />,
    software: [
      {
        name: "网易云音乐",
        description: "网易旗下的一款免费在线音乐播放软件，它的音乐评论很有趣，能够发现很多有故事的句子和人。",
        url: "https://music.163.com/",
        isFree: true
      },
      {
        name: "foobar2000",
        description: "可以自定义的音乐播放器，可以优秀的完成本地音乐的播放任务。",
        url: "https://www.foobar2000.org/",
        isFree: true
      },
      {
        name: "QQ 音乐",
        description: "腾讯公司旗下的在线音乐软件。",
        url: "https://y.qq.com/",
        isFree: true,
        hasAds: true
      },
      {
        name: "Spotify",
        description: "全球最大的音乐流媒体服务，提供数百万首歌曲和播客。",
        url: "https://www.spotify.com/",
        isFree: true,
        isPremium: true
      },
      {
        name: "CastLoom Pro",
        description: "播客软件。从播客到知识库，一步到位。播放、下载、转录、翻译、归档，支持 Windows 与 macOS，7 天免费试用，一次购买终身授权。",
        url: "https://castloompro.toolooz.com/",
        isPremium: true
      }
    ]
  },
  {
    name: "影视",
    icon: <FaPlay className="text-red-500" />,
    software: [
      {
        name: "QQ 影音",
        description: "腾讯公司旗下的一款影音播放器，简洁高效，支持多种文件格式，没有广告，良心软件。",
        url: "https://player.qq.com/",
        isFree: true
      },
      {
        name: "VLC",
        description: "开源的跨平台多媒体播放器，几乎支持所有的多媒体文件格式。",
        url: "https://www.videolan.org/vlc/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "PotPlayer",
        description: "一款全面的多媒体播放器，拥有强大的功能和高度的可定制性。",
        url: "https://potplayer.daum.net/",
        isFree: true
      }
    ]
  },
  {
    name: "办公",
    icon: <FaFileWord className="text-indigo-600" />,
    software: [
      {
        name: "Microsoft Office",
        description: "无可厚非，Office依旧很好用，Word、PPT、Excel都是办公必备。",
        url: "https://www.office.com/",
        isPremium: true
      },
      {
        name: "WPS",
        description: "金山软件提供的Office替代软件，免费可以使用，也提供付费服务。",
        url: "https://www.wps.cn/",
        isFree: true,
        isPremium: true
      },
      {
        name: "LibreOffice",
        description: "开源的办公套件，完全免费，兼容Microsoft Office文档格式。",
        url: "https://www.libreoffice.org/",
        isFree: true,
        isOpenSource: true
      }
    ]
  },
  {
    name: "写作",
    icon: <FaEdit className="text-green-600" />,
    software: [
      {
        name: "Typora",
        description: "Markdown 新秀，体验很棒的MD文件编辑器。",
        url: "https://typora.io/",
        isFree: true
      },
      {
        name: "Notion",
        description: "集笔记、知识库与任务管理于一体的全能型工作区。",
        url: "https://www.notion.so/",
        isFree: true,
        isPremium: true
      },
      {
        name: "Obsidian",
        description: "强大的知识库应用程序，基于本地Markdown文件。",
        url: "https://obsidian.md/",
        isFree: true,
        isPremium: true
      }
    ]
  },
  {
    name: "效率",
    icon: <FaCheckSquare className="text-orange-500" />,
    software: [
      {
        name: "Microsoft To Do",
        description: "微软公司的待办事项清单应用，可在应用商店下载。",
        url: "https://todo.microsoft.com/tasks/",
        isFree: true
      },
      {
        name: "Microsoft OneNote",
        description: "微软公司的笔记应用，系统全面的笔记记录，推荐使用数位板记录，会有意想不到效果。",
        url: "https://www.microsoft.com/zh-cn/microsoft-365/onenote/digital-note-taking-app",
        isFree: true
      },
      {
        name: "Trello",
        description: "可视化的项目管理工具，使用看板方法组织任务。",
        url: "https://trello.com/",
        isFree: true,
        isPremium: true
      }
    ]
  },
  {
    name: "输入法",
    icon: <FaKeyboard className="text-blue-400" />,
    software: [
      {
        name: "小狼毫",
        description: "Rime 输入法的Windows平台名称，主要的有点就是相应速度快，简单，都与没啥要求的人来说，挺好配置，当然也可以很复杂。",
        url: "https://rime.im/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "搜狗输入法 智慧板",
        description: "搜狗旗下的输入法，老牌子了,拥有强大的词库，输入体验良好，功能丰富，但是会有至少一次的广告弹窗。",
        url: "https://pinyin.sogou.com/zhihui/",
        isFree: true,
        hasAds: true
      },
      {
        name: "QQ 输入法",
        description: "腾讯公司旗下的输入法软件。",
        url: "http://qq.pinyin.cn/",
        isFree: true
      }
    ]
  },
  {
    name: "安全",
    icon: <FaShieldAlt className="text-red-600" />,
    software: [
      {
        name: "360安全卫士",
        description: "奇虎360公司的安全系列软件。",
        url: "https://www.360.cn/",
        isFree: true,
        hasAds: true
      },
      {
        name: "火绒安全",
        description: "简约，高效的安全软件，网络评价比较好，无广告。",
        url: "https://www.huorong.cn/",
        isFree: true
      },
      {
        name: "Windows Defender",
        description: "Windows 10/11自带的安全软件，提供基本的防护功能，无广告，不影响系统性能。",
        url: "https://www.microsoft.com/en-us/windows/comprehensive-security",
        isFree: true
      }
    ]
  },
  {
    name: "压缩",
    icon: <FaFileArchive className="text-yellow-600" />,
    software: [
      {
        name: "360 压缩",
        description: "奇虎360 公司的免费压缩软件，自带杀毒。",
        url: "https://yasuo.360.cn/",
        isFree: true,
        hasAds: true
      },
      {
        name: "7-zip",
        description: "7-Zip 是一款拥有极高压缩比的开源压缩软件。",
        url: "https://sparanoid.com/lab/7z/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "WinRAR",
        description: "老牌的压缩软件，界面简洁，功能强大。",
        url: "https://www.rarlab.com/",
        isPremium: true
      }
    ]
  },
  {
    name: "截图",
    icon: <FaCamera className="text-purple-500" />,
    software: [
      {
        name: "FastStone Capture",
        description: "截图编辑，软件的编辑功能完善，成图效果好，可以滚动截屏。",
        url: "https://www.faststone.org/FSCaptureDownload.htm",
        isPremium: true
      },
      {
        name: "ShareX",
        description: "功能强大，支持上传图床，为截图自动处理滤镜等，后起之秀，反响不错。",
        url: "https://getsharex.com/",
        isFree: true
      },
      {
        name: "Snipaste",
        description: "简单但强大的截图工具，还可以将截图贴在屏幕上。",
        url: "https://www.snipaste.com/",
        isFree: true
      }
    ]
  },
  {
    name: "录屏",
    icon: <FaDesktop className="text-green-500" />,
    software: [
      {
        name: "OBS Studio",
        description: "开源免费的录屏、直播软件，插件丰富，可以实现很多效果，口碑好。",
        url: "https://obsproject.com/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "Bandicam",
        description: "高性能的屏幕录制软件，可以录制特定区域或游戏画面。",
        url: "https://www.bandicam.com/",
        isPremium: true
      },
      {
        name: "ScreenToGif",
        description: "录制屏幕区域并保存为GIF动画，方便制作小型演示。",
        url: "https://www.screentogif.com/",
        isFree: true,
        isOpenSource: true
      }
    ]
  },
  {
    name: "后期处理",
    icon: <FaFilm className="text-pink-500" />,
    software: [
      {
        name: "DaVinci Resolve",
        description: "免费的跨平台后期处理软件，完整的处理流程体验。",
        url: "https://www.blackmagicdesign.com/products/davinciresolve/",
        isFree: true,
        isPremium: true
      },
      {
        name: "Adobe Premiere Pro",
        description: "专业的视频编辑软件，行业标准的非线性视频编辑工具。",
        url: "https://www.adobe.com/products/premiere.html",
        isPremium: true
      },
      {
        name: "剪映",
        description: "字节跳动旗下的视频剪辑软件，功能丰富，适合入门用户。",
        url: "https://www.capcut.cn/",
        isFree: true
      }
    ]
  },
  {
    name: "开发",
    icon: <FaCode className="text-blue-700" />,
    software: [
      {
        name: "Visual Studio",
        description: "号称windows平台宇宙最强IDE，同时体积也很大。",
        url: "https://visualstudio.microsoft.com/zh-hans/",
        isFree: true,
        isPremium: true
      },
      {
        name: "Visual Studio Code",
        description: "宇宙最强IDE Visual Studio 的精简版。",
        url: "https://code.visualstudio.com/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "JetBrains 系列",
        description: "专业的IDE系列，包括IntelliJ IDEA、PyCharm、WebStorm等。",
        url: "https://www.jetbrains.com/",
        isPremium: true
      }
    ]
  },
  {
    name: "终端",
    icon: <FaTerminal className="text-gray-800" />,
    software: [
      {
        name: "Windows Terminal",
        description: "Windows 官方出品的一款终端工具，相比之前的CMD风格，美化不少。",
        url: "https://aka.ms/terminal",
        isFree: true
      },
      {
        name: "PowerShell 7",
        description: "微软的现代命令行工具，比传统的PowerShell功能更强大。",
        url: "https://github.com/PowerShell/PowerShell",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "Git Bash",
        description: "Windows上的Git命令行工具，提供类Unix的shell环境。",
        url: "https://gitforwindows.org/",
        isFree: true,
        isOpenSource: true
      }
    ]
  }
]

const sidebarItems = [
  { title: "装机工具", path: "/tools", icon: <FaTools /> },
  { title: "PE工具", path: "/petools", icon: <FaCompactDisc /> },
  { title: "激活工具", path: "/activators", icon: <FaKey /> },
  { title: "系统下载", path: "/downloads", icon: <FaDownload /> },
  { title: "Windows软件", path: "/windows-software", icon: <FaWindows /> },
  { title: "MacOS软件", path: "/macos-software", icon: <FaApple /> },
  { title: "安装U盘推荐", path: "/usb-recommend", icon: <FaUsb /> },
  { title: "电脑选购推荐", path: "/computer-recommend", icon: <FaDesktop /> }
]

const WindowsSoftware = () => {
  return (
    <DocsLayout sidebarItems={sidebarItems}>
      <SEO 
        title="Windows软件推荐"
        description="精选Windows平台优质软件推荐，包括系统工具、办公软件、多媒体软件等，打造高效实用的电脑环境。"
        keywords="Windows软件,系统工具,办公软件,多媒体软件,实用工具,免费软件"
      />
      <motion.h1 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-primary mb-8 text-center flex items-center justify-center"
      >
        <FaWindows className="mr-3 text-primary" />
        Windows 软件推荐
      </motion.h1>
      
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-gray-600 mb-8 text-center"
      >
        这里收集了各类 Windows 平台优质软件，帮助你打造高效实用的电脑环境。
      </motion.p>
      
      <div className="space-y-12">
        {softwareCategories.map((category, categoryIndex) => (
          <motion.div 
            key={category.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: categoryIndex * 0.1 }}
            className="bg-white shadow-md rounded-xl overflow-hidden"
          >
            <div className="bg-blue-50 p-4 flex items-center border-b border-blue-100">
              <div className="text-2xl mr-3">{category.icon}</div>
              <h2 className="text-2xl font-bold text-gray-800">{category.name}</h2>
            </div>
            
            <div className="divide-y divide-gray-100">
              {category.software.map((software, index) => (
                <div key={software.name} className="p-4 hover:bg-gray-50 transition-colors">
                  <div className="flex justify-between items-start">
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">{software.name}</h3>
                    <div className="flex space-x-1">
                      {software.isFree && (
                        <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">免费</span>
                      )}
                      {software.isPremium && (
                        <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full">付费</span>
                      )}
                      {software.hasAds && (
                        <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">有广告</span>
                      )}
                      {software.isOpenSource && (
                        <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">开源</span>
                      )}
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm mb-2">{software.description}</p>
                  <a
                    href={software.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-primary hover:text-primary-dark text-sm"
                  >
                    访问官网
                    <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </DocsLayout>
  )
}

export default WindowsSoftware 